export function getOrganizationNavLink(type: string, slug: string, link: string): string {
  return link === '#about' ? `/${type}/${slug}` : `/${type}/${slug}/${link}`
}
